<template>
  <div>
    <h1 class="text-2xl font-bold text-custom-blue mb-6">MOH Statutory Forms</h1>
    <MohStatutoryForms />
  </div>
</template>

<script setup>
import MohStatutoryForms from '@/views/pages/statistical_reports/MohStatutoryForms.vue'
</script>
